console.log('Custom JS loaded');

const retinaImages = () => {
  const productsDataSrcImages = [...document.querySelectorAll('.products img[data-src]')];

  const replaceAttributeValue = (img, attributeName) => {
    const attributeValue = img.getAttribute(attributeName);
    img.setAttribute(attributeName, attributeValue.replace('/detail/', '/big/'));
  };

  productsDataSrcImages.forEach((img) => {
    replaceAttributeValue(img, 'src');
    replaceAttributeValue(img, 'data-src');
  });


  // const categoryImages = [...document.querySelectorAll('img[data-src]')].filter((img) => img.getAttribute('data-src').includes('/user/categories/thumb/'));

  // categoryImages.forEach((img) => {
  //   if (img.closest('a').getAttribute('href') === '/cbg/') {
  //     img.setAttribute('src', `/user/documents/img/vectors/vector-cbg.svg`);
  //     img.setAttribute('data-src', `/user/documents/img/vectors/vector-cbg.svg`);
  //   }
  // });
}

const replaceFakeCategoryLinks = () => {
  const fakeMenuLinks = [...document.querySelectorAll('#navigation a[href*="link_"]')];
  fakeMenuLinks.forEach((link) => {
    link.setAttribute('href', link.getAttribute('href').replace(/link_/g, ''));
  });

  if (window.location.href.includes('link_')) {
    window.location.href = window.location.href.replace('link_', '');
  }
}

// const initPreheader = () => {
//   const topNavigationBar = document.querySelector('.top-navigation-bar');
//   const navigation = document.querySelector('#navigation');

//   if (topNavigationBar && navigation) {
//     topNavigationBar.insertAdjacentHTML('beforebegin', `
//       <div class="preheader">
//         <nav class="container">

//         </nav>
//       </div>
//     `);


//     const preheaderContainer = document.querySelector('.preheader');
//     if (preheaderContainer) {
//       const navigationLinks = [...document.querySelectorAll('.custom-footer>div:first-of-type ul li a')]
//         .filter((link, index) => index >= 2);

//       navigationLinks.forEach((link) => {
//         link.parentNode.style.display = 'none';
//       });

//       const navigationLinksHtml = navigationLinks.map((link) => link.outerHTML).join('\n');

//       preheaderContainer.querySelector('.container').innerHTML = navigationLinksHtml;
//     }

//   }
// }


const initHomepageCarousel = () => {
  const carouselVideo = document.querySelector('#carousel .js-hp-hero-video');

  if (carouselVideo) {
    carouselVideo.addEventListener('click', () => {
      if (!carouselVideo.classList.contains('is-video-visible')) {
        carouselVideo.querySelector('iframe').setAttribute('src', 'https://www.youtube.com/embed/W1AGo-7AxA4');
        carouselVideo.classList.add('is-video-visible');
      }
    });
  }

  const hpCategoriesItems = document.querySelector('.js-hp-categories-items');
  if (hpCategoriesItems) {
    const navigationCategories = [...document.querySelectorAll('#navigation li:first-of-type ul li a.menu-image')];
    hpCategoriesItems.innerHTML = navigationCategories.filter((category, index) => index !== 0).map((link) => {
      const href = link.getAttribute('href');
      const img = link.querySelector('img');
      // const icon = img ? img.getAttribute('data-src') : '';
      const title = img ? img.getAttribute('alt') : '';

      return `
        <div class="hp-grid__item">
          <div class="hp-grid__item-icon">
            <img src="/user/documents/img/vectors/vector-${href.replace(/\//g, '')}.svg" alt="${title}">
          </div>
          <h3>
            ${title}
          </h3>
          <a href="${href}" class="btn btn-secondary btn-transparent btn--with-arrow">
            Přejít do kategorie
          </a>
          <br>
        </div>
      `;
    }).join('\n');

    hpCategoriesItems.insertAdjacentHTML('afterend', `
      <div style="text-align: center;">
        <a href="/cannacare/" class="btn btn-secondary btn--with-arrow">
          Všechny produkty
        </a>
      </div>
    `);
  }


  const productsBlock = document.querySelector('.in-index .products-block');
  if (productsBlock) {
    productsBlock.insertAdjacentHTML('afterend', `
      <div style="text-align: center; margin-top: 42px; margin-bottom: 72px;">
        <a href="/cannacare/" class="btn btn-secondary btn--with-arrow">
          Všechny produkty
        </a>
      </div>
    `);
  }

  $(".hp-icons").appendTo(".wide-carousel");
  $(".homepage-brands").insertBefore(".content-wrapper.homepage-box.welcome-wrapper");
};


const initHomepageProducts = () => {
  const homepageProductsBlock = document.querySelector('.in-index .products-block');

  if (homepageProductsBlock) {
     const firstProductLineEnd = homepageProductsBlock.querySelector('.product:nth-child(3)');
     if (firstProductLineEnd) {
      firstProductLineEnd.insertAdjacentHTML('afterend', `
        <div class="product product--category">
          <a href="/cbd-olej/">
            <img src="/user/documents/img/hp-category-olej.png" alt="CDB Oleje" loading="lazy">
          </a>
        </div>
      `);
     }

     const products = homepageProductsBlock.querySelectorAll('.product');
     if (products && products[6]) {
      products[6].insertAdjacentHTML('afterend', `
        <div class="product product--category">
          <a href="/cbd-kapsle/">
            <img src="/user/documents/img/hp-category-kapsle.png" alt="CBD kapsle" loading="lazy">
          </a>
        </div>
      `);
     }
  }
};

const initHomepageBlog = () => {
  setTimeout(() => {
    const blogHp = document.querySelector('.blog-hp');

    if (blogHp) {
      const newsItems = [...blogHp.querySelectorAll('.news-item')];
      newsItems.forEach((item) => {
        const linkHref = item.querySelector('a').getAttribute('href');

        item.insertAdjacentHTML('beforeend', `
          <a class="btn btn-secondary btn--with-arrow" href="${linkHref}">
            Zobrazit článek
          </a>
        `);
      });
    }
  }, 2000);
}

const initFAQBlog = () => {
  const homepageBox = document.querySelector('.welcome-wrapper');

  if (homepageBox) {
    homepageBox.insertAdjacentHTML('afterend', `
      <div class="container faq-block">
        <div class="faq">
          <h2>
              <span class="black">5 důvodů, proč CBD<br></span>
              roste na popularitě
          </h2>
          <div class="faq__item">
            <div class="faq__item-number like-h2">
              1
            </div>
            <div class="faq__item-text">
              <h3>
                To nejlepší z rostliny konopí
                bez omamných účinků
              </h3>
              <p>
                CBD není psychoaktivní a je naprosto legální
              </p>
            </div>
          </div>
          <div class="faq__item">
            <div class="faq__item-number like-h2">
              2
            </div>
            <div class="faq__item-text">
              <h3>
                Přírodní zbraň proti nespavosti
              </h3>
              <p>
                Mnoha lidem slouží jako skvělý doplněk pro podporu spánku
              </p>
            </div>
          </div>
          <div class="faq__item">
            <div class="faq__item-number like-h2">
              3
            </div>
            <div class="faq__item-text">
              <h3>
                Úleva od tlaku dnešní doby
              </h3>
              <p>
                Nechte stres a úzkosti daleko za sebou s CBD
              </p>
            </div>
          </div>
          <div class="faq__item">
            <div class="faq__item-number like-h2">
              4
            </div>
            <div class="faq__item-text">
              <h3>
                Podpora regenerace organismu
              </h3>
              <p>
                CBD si již našlo cestu z profesionálního sportu i do běžného života
              </p>
            </div>
          </div>
          <div class="faq__item">
            <div class="faq__item-number like-h2">
              5
            </div>
            <div class="faq__item-text">
              <h3>
                Normální fungování imunity
              </h3>
              <p>
                Oslabenou imunitou trpí většina populace, CBD podporuje její správné fungování
              </p>
            </div>
          </div>
          <div class="faq__itemBtn">
            <a href="/cbd-produkty/" class="btn btn-secondary btn--with-arrow">
              Více o CBD
            </a>
          </div>
        </div>
        <div class="faq background">
          <h2>
              <span class="black">5 důvodů, proč</span><br>nakupovat na CannaPlus
          </h2>
          <div class="faq__item">
            <div class="faq__item-number like-h2">
              1
            </div>
            <div class="faq__item-text">
              <h3>
                Pocházíme z dobré rodiny
              </h3>
              <p>
                Patří do ní mimo jiné český výrobce doplňků stravy z konopí, společnost CannaCare nebo experimentální program aplikační léčby kanabinoidy (HARP).
              </p>
            </div>
          </div>
          <div class="faq__item">
            <div class="faq__item-number like-h2">
              2
            </div>
            <div class="faq__item-text">
              <h3>
                Více než 10 let zkušeností v oboru
              </h3>
              <p>
                Nevznikli jsme přes noc - Výzkumu a terapeutickému potenciálu konopí se věnujeme s láskou již více než 10 let.
              </p>
            </div>
          </div>
          <div class="faq__item">
            <div class="faq__item-number like-h2">
              3
            </div>
            <div class="faq__item-text">
              <h3>
                Prémiové značky produktů
              </h3>
              <p>
                Vybíráme pro Vás pouze ověřené značky, které splňují nároky na kvalitu, výrobní postupy a nabízí produkty v souladu s legislativou.
              </p>
            </div>
          </div>
          <div class="faq__item">
            <div class="faq__item-number like-h2">
              4
            </div>
            <div class="faq__item-text">
              <h3>
                Testování a analýzy produktů
              </h3>
              <p>
                Pečlivě pro Vás vybíráme a společně s VŠCHT testujeme všechny produkty před zařazením do nabídky.
              </p>
            </div>
          </div>
          <div class="faq__item">
            <div class="faq__item-number like-h2">
              5
            </div>
            <div class="faq__item-text">
              <h3>
                Odborné poradenství
              </h3>
              <p>
                Rádi Vás vyslechneme a pomůžeme s výběrem vhodného produktu na základě zkušeností našich, či našich zákazníků
              </p>
            </div>
          </div>
          <div class="faq__itemBtn">
            <a href="/cannaplus/" class="btn btn-secondary btn--with-arrow">
              Více o nás
            </a>
          </div>
        </div>
      </div>
    `);
  }
}

const initTopNavigationBar = () => {
  const topNavigationBar = document.querySelector('.top-navigation-bar');

  if (topNavigationBar) {
    const topNavigationBarContacts = topNavigationBar.querySelector('.top-navigation-contacts');
    const topNavigationBarContactsLinks = topNavigationBarContacts.querySelectorAll('a');

    if (topNavigationBarContactsLinks[0]) {
      const topNavigationBarContactsLinksPhone = topNavigationBarContactsLinks[0];

      topNavigationBarContactsLinksPhone.insertAdjacentHTML('beforebegin', `
      <span class="project-contact-icon">
        <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.676 15.595c-.556 1.688-2.733 2.53-4.288 2.39-2.124-.192-4.435-1.319-6.19-2.56-2.578-1.824-4.993-4.645-6.4-7.639-.996-2.115-1.219-4.717.26-6.645C1.607.428 2.199.048 3.088.004c1.233-.06 1.406.645 1.83 1.744.315.822.736 1.661.972 2.513.44 1.59-1.1 1.656-1.294 2.955-.121.82.872 1.92 1.321 2.504a12.126 12.126 0 003.13 2.883c.682.43 1.785 1.207 2.568.779 1.204-.66 1.09-2.692 2.775-2.004.872.355 1.717.868 2.55 1.316 1.288.693 1.228 1.41.737 2.9-.367 1.114.367-1.113 0 0" fill="currentColor" fill-rule="evenodd"/>
        </svg>
      </span>
      <span class="project-contact-prefix">Zavolej nám</span>
    `);
    }

    if (topNavigationBarContactsLinks[1]) {
      const topNavigationBarContactsLinksMail = topNavigationBarContactsLinks[1];

      topNavigationBarContactsLinksMail.insertAdjacentHTML('beforebegin', `
      <span class="project-contact-icon">
        <svg width="24" height="18" viewBox="0 0 24 18" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 14.969L0 4.379V18h24V4.379l-12 10.59zm.001-3.195L0 1.177V0h24v1.177L12.001 11.774z" fill="currentColor" fill-rule="evenodd"/>
        </svg>
      </span>
      <span class="project-contact-prefix">
        Napište nám
      </span>
    `);
    }

    /*topNavigationBarContacts.insertAdjacentHTML('beforeend', `
      <span class="project-contact-icon">
        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.542 1.507C7.11-1.493 1.79.205.608 4.654.112 6.522.59 7.388.59 8.79c0 1.44-.59 3.527-.59 3.527 0 .255.226.504.506.432.997-.262 2.584-.778 4.482-.263 6.382 1.73 10.477-6.677 5.554-10.979M15.558 16a.53.53 0 01-.128-.016c-5.045-1.267-4.707.155-7.51-.594a6.286 6.286 0 01-2.286-1.164c5.09.624 9.335-3.812 8.584-9.036.768.8 1.332 1.79 1.57 2.9.68 3.15-1.044 2.616.2 7.402.072.28-.176.508-.43.508" fill="#334C45" fill-rule="evenodd"/>
      </svg>
      </span>
      <span class="project-contact-prefix">
        Poradna
      </span>
      <a href="#" class="project-chat" onclick="Intercom('show')">
        <span><strong>Otevřít chat</strong></span>
      </a>
    `);*/ // Temporary

    topNavigationBar.insertAdjacentHTML('beforebegin', `
      <div class="top-notification-bar">
          <div class="container">
              Doprava zdarma při nákupu nad 1&nbsp;000 Kč
          </div>
      </div>
    `);
  }
};


const initProductDetail = () => {
  const productDetail = document.querySelector('.type-detail');
  if (productDetail) {
    /*
    const pShortDescription = document.querySelector('.p-short-description');
    const pShortDescriptionLinks = [...pShortDescription.querySelectorAll('a')];
    const pDetailTabs = productDetail.querySelector('#p-detail-tabs');
    const tabContent = productDetail.querySelector('#tab-content');

    if (pShortDescription) {
      pShortDescriptionLinks.forEach((link, index) => {
        const href = link.getAttribute('href');

        if (href.includes('.pdf')) {
          pDetailTabs.insertAdjacentHTML('beforeend', `
            <li class="shp-tab">
              <a href="${href}" class="shp-tab-link" target="_blank">${link.textContent}</a>
            </li>
          `);
        } else {
          pDetailTabs.insertAdjacentHTML('beforeend', `
            <li class="shp-tab">
              <a href="#custom-tab-${index}" class="shp-tab-link" role="tab" data-toggle="tab">${link.textContent}</a>
            </li>
          `);

          tabContent.insertAdjacentHTML('beforeend', `
            <div id="custom-tab-${index}" class="tab-pane fade" role="tabpanel">
              <div class="description-inner">
                <img src="${href}" alt="${link.textContent}">
              </div>
            </div>
          `);
        }
      });

    }
    */

    //$('.p-short-description').prependTo('.p-info-wrapper');
    $('.p-detail-inner-header').prependTo('.p-info-wrapper');
    $('.availability-value').insertAfter('.add-to-cart');
    $('.p-info-wrapper .add-to-cart').wrapAll('<div class="add-to-cart-wrapper flex-between-center-wrap"></div>');
    $('.p-info-wrapper .p-final-price-wrapper').prependTo('.p-info-wrapper .add-to-cart-wrapper');
    $(".p-final-price-wrapper").append(`
      <div class="extra delivery">
        <span>Doprava zdarma od 1000 Kč</span>
      </div>
    `);
    $(".availability-value").insertBefore(".p-detail .add-to-cart-wrapper");

    const needHelpBlock = `
      <div class="needHelpBlock">
        <div class="needHelpBlock__column">
          <div class="needHelpBlock__column-img">
            <img src="/user/documents/img/help-operator.jpg" alt="CannaPlus" />
          </div>
          <div class="needHelpBlock__column-info">
            <p>
              <strong>
                Potřebujete poradit?
              </strong><br>
              <span class="green">
                Jsme online!
              </span>
            </p>
            <a class="openChat" onclick="Intercom('show')">
              Otevřít chat
            </a>
          </div>
        </div>
        <div class="needHelpBlock__column needHelpBlock__column--column">
          <div class="needHelpBlock__column-link">
            <svg width="12" height="14" viewBox="0 0 12 14" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.895 0a5.294 5.294 0 00-2.96.89c-.905.593-1.62 1.4-2.146 2.422A7.188 7.188 0 000 6.65C0 7.854.263 8.967.789 9.99c.525 1.022 1.241 1.829 2.147 2.422.906.593 1.892.89 2.959.89a5.294 5.294 0 002.959-.89c.905-.593 1.621-1.4 2.147-2.422a7.188 7.188 0 00.788-3.339 7.188 7.188 0 00-.788-3.338C10.475 2.29 9.759 1.482 8.854.89A5.294 5.294 0 005.894 0zm0 12.483c-.56 0-1.104-.098-1.63-.293a4.62 4.62 0 01-1.421-.837 6.21 6.21 0 01-1.111-1.26 5.76 5.76 0 01-.737-1.605 6.541 6.541 0 01-.26-1.838c0-.788.137-1.54.41-2.26a5.944 5.944 0 011.1-1.857 5.19 5.19 0 011.645-1.24A4.554 4.554 0 015.895.83c.698 0 1.366.154 2.003.461a5.19 5.19 0 011.646 1.24c.46.52.827 1.14 1.1 1.858.272.72.409 1.472.409 2.26 0 .788-.137 1.542-.41 2.26a6.027 6.027 0 01-1.099 1.865c-.46.523-1.009.94-1.646 1.247a4.554 4.554 0 01-2.003.46zm.368-6.001V2.494a.426.426 0 00-.11-.292.336.336 0 00-.258-.124c-.1 0-.186.041-.26.124a.426.426 0 00-.109.292V6.65c0 .122.039.221.115.3l.006.012.006.013 1.83 2.052c.07.087.156.13.26.13.103 0 .19-.04.259-.123a.45.45 0 00.103-.299.424.424 0 00-.103-.292L6.263 6.482z" fill="#000" fill-rule="nonzero"/>
            </svg>
            <span>
              Po-Pá 9:00 - 17:00
            </span>
          </div>
          <a href="tel:+420602549010" class="needHelpBlock__column-link">
            <svg width="12" height="14" viewBox="0 0 12 14" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.963.558c.457.707.995 1.613 1.613 2.718.153.29.129.647-.072 1.073-.064.145-.257.548-.578 1.21.064.108.139.221.223.339l.27.374c.097.13.202.264.314.4.112.136.23.279.355.428.125.15.255.302.392.455.706.798 1.292 1.386 1.758 1.767.522-.344.879-.57 1.072-.68.2-.126.393-.19.578-.19.144 0 .269.036.373.109.715.49 1.526 1.096 2.433 1.82.16.146.257.336.289.571.024.245-.044.507-.205.788-.064.109-.189.29-.373.544a9.281 9.281 0 01-.765.897c-.341.362-.62.543-.837.543h-.024c-.827-.036-1.746-.403-2.758-1.1-1.012-.698-2.12-1.722-3.324-3.071C1.297 6.835.064 4.548 0 2.69c0-.244.16-.566.482-.964.313-.38.574-.666.783-.856.208-.181.377-.322.505-.421a.913.913 0 01.59-.204c.257 0 .458.104.603.312zm-.771.557a7.731 7.731 0 00-.915.883c-.29.327-.458.567-.506.72.064 1.631 1.218 3.71 3.462 6.237s4.093 3.836 5.546 3.927c.12-.055.325-.25.614-.585.29-.335.55-.684.783-1.046a.337.337 0 00.048-.102.165.165 0 000-.088 66.667 66.667 0 00-2.336-1.766.521.521 0 00-.241.081c-.032.018-.16.1-.385.245s-.446.28-.663.407l-.397.272-.398-.299c-.506-.39-1.128-1.01-1.866-1.861-.723-.825-1.265-1.527-1.626-2.106l-.29-.421.242-.476.578-1.182a.704.704 0 00.072-.272 79.697 79.697 0 00-1.53-2.622H2.36a.273.273 0 00-.168.054z" fill="#000" fill-rule="nonzero"/>
            </svg>
            <span>
              +420 602 549 010
            </span>
          </a>
          <a href="mailto:info@cannaplus.cz" class="needHelpBlock__column-link">
            <svg width="15" height="13" viewBox="0 0 15 13" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.755 2.026a.343.343 0 000-.196l-.029-.097c-.115-.586-.486-.879-1.11-.879h-12c-.29 0-.566.06-.83.179-.264.12-.464.282-.599.488l-.072.082a.503.503 0 00-.1.423A.16.16 0 000 2.09v8.396c0 .434.173.846.52 1.237.345.39.71.586 1.095.586h12c.356 0 .637-.185.844-.554.207-.368.31-.792.31-1.269v-8.42l-.014-.041zm-13.14-.13h12l-6.23 5.613-6.217-5.597a3.91 3.91 0 01.447-.017zm12 9.372h-12c-.086 0-.185-.043-.295-.13a1.2 1.2 0 01-.282-.317.655.655 0 01-.115-.334V3.035l6.159 5.548c.086.087.187.13.303.13a.522.522 0 00.303-.13l6.158-5.548v7.517c0 .478-.077.716-.23.716z" fill="#000" fill-rule="nonzero"/>
            </svg>
            <span>
              info@cannaplus.cz
            </span>
          </a>
        </div>
      </div>
    `;

    const needBlockBig = `
      <div class="needHelpBlockBig">
        <div class="needHelpBlockBigContainer">
        <h2>
          Potřebujete poradit?
        </h2>
          ${needHelpBlock}
        </div>
      </div>
    `;

    const infoBlock = productDetail.querySelector('.p-info-wrapper')

    if (infoBlock) {
      //infoBlock.insertAdjacentHTML('beforeend', needHelpBlock);
    }

    const contentWrapper = productDetail.querySelector('#content-wrapper');

    if (contentWrapper) {
      contentWrapper.insertAdjacentHTML('beforeend', needBlockBig);
    }

    const adultAlert = `
      <div class="adultAlert">
        <div class="adultAlert__block">
          <h4>
            Potvrzuji, že jsem starší 18 let.
          </h4>
          <p>
          Z důvodu dodržení zákona č. 65/2017 Sb. O ochraně zdraví je vstup na tuto část webu a následný nákup vybraného zboží povolen pouze osobám starším 18 let.
          </p>
          <div class="adultAlert__block-buttons">
            <button type="button" onclick="closeAdultAlert(false)" class="text">
              Ne, odejít
            </button>
            <button type="button" class="btn btn-secondary btn--with-arrow" onclick="closeAdultAlert(true)">
              Ano, pokračovat
            </button>
          </div>
        </div>
      </div>
    `;

    if (!window.sessionStorage.getItem('adultCheck') && document.body.classList.contains('in-cbd-kvety')) {
      productDetail.insertAdjacentHTML('beforeend', adultAlert);
    }
  }
};

const closeAdultAlert = (setSession) => {
  const adultAlert = document.querySelector('.adultAlert');

  if (adultAlert) {
    adultAlert.classList.add('is-hide');

    if (setSession) {
      window.sessionStorage.setItem('adultCheck', true);
    } else {
      window.location.href="/";
    }
  }
};

const initPageDetail = () => {
  const pageDetail = document.querySelector('.type-page');
  if (pageDetail) {
    $('#content .content-inner .cta-block').appendTo('#content');
  }
};

const initEmptyCart = () => {
  const emptyCartHeading = document.querySelector('.cart-empty .cart-heading');

  if (emptyCartHeading) {
    /*emptyCartHeading.insertAdjacentHTML('afterend', `
      <div style="margin-top: 40px; margin-bottom: 60px; text-align: center;">
        <button class="btn btn-secondary" onclick="Intercom('show')">
          Potřebujete poradit?
        </button>
      </div>
    `);*/ // Temporary
  }

  const orderingProcess = document.querySelector('.ordering-process');
  if (orderingProcess && !emptyCartHeading) {
    document.body.classList.add('is-intercom-hidden');

    const birthDateInput = orderingProcess.querySelector('#birthdate');
    if (birthDateInput) {
      birthDateInput.insertAdjacentHTML('afterend', `
        <span style="
            margin-top: 5px;
            display: block;
            font-size: 12px;
            opacity: 0.7;
        ">Svěřte se nám, abychom se mohli připravit na Vaše narozeniny.</span>
      `);
    }

    const paymentByCardLabel = document.querySelector('label#name-billingId-21');
    if (paymentByCardLabel) {
      paymentByCardLabel.setAttribute('for', 'PlnRI1');

      // const i = paymentByCardLabel.parentNode.querySelector('i');
      // i.parentNode.removeChild(i);

      paymentByCardLabel.querySelector('.payment-info').insertAdjacentHTML('afterend', `
        <span class="payment-logo">
            <img src="https://static.payu.com/jsgenerator/images/on-c.gif" alt="VISA, MasterCard">
        </span>
      `);
    }

    // const logRocketScript = document.createElement('script');
    // logRocketScript.onload = () => {
    //     if (window.LogRocket) {
    //       window.LogRocket.init('cannacare/cannacare-eshop');

    //       const orderNumber = orderingProcess.querySelector('.reca-number strong');

    //       if (orderNumber) {
    //         console.log(orderNumber);
    //         window.LogRocket.identify(orderNumber.textContent);
    //       }
    //     }
    // };
    // logRocketScript.crossorigin = 'anonymous';
    // logRocketScript.src = 'https://cdn.lr-ingest.io/LogRocket.min.js';
    // document.head.appendChild(logRocketScript);
  }
};

const initB2B = () => {
  const shoptetDataLayer = dataLayer && dataLayer.find((layer) => layer.shoptet) && dataLayer.find((layer) => layer.shoptet).shoptet;

  const GROUP_KAMENNA_PODEJNA = 2;
  const GROUP_ESHOP = 6;
  const GROUP_JINE = 9;

  let MIN_PRICE = 10000;
  let MIN_PRICE_TEXT = '10&nbsp;000&nbsp;Kč';


  if (shoptetDataLayer && shoptetDataLayer.customer && (shoptetDataLayer.customer.groupId === GROUP_KAMENNA_PODEJNA || shoptetDataLayer.customer.groupId === GROUP_ESHOP || shoptetDataLayer.customer.groupId === GROUP_JINE)) {
    document.body.classList.add('is-b2b');

    if (shoptetDataLayer.customer.groupId === GROUP_KAMENNA_PODEJNA) {
      MIN_PRICE = 5000;
      MIN_PRICE_TEXT = '5&nbsp;000&nbsp;Kč';
    }

    const topNotificationBarContainer = document.querySelector('.top-notification-bar .container');
    if (topNotificationBarContainer) {
      topNotificationBarContainer.innerHTML = `Minimální objednávka je ${MIN_PRICE_TEXT} bez DPH`;
    }

    if (document.body.classList.contains('ordering-process')) {
      const checkCart = () => {
        if (!document.querySelector('.cart-minimum-order')) {
          document.querySelector('.price-wrapper').insertAdjacentHTML('afterend', `
              <div class="cart-minimum-order">
                Minimální cena objednávky je <strong>${MIN_PRICE_TEXT}</strong> bez&nbsp;DPH
              </div>
          `);
        }

        const totalPriceWithoutVat = +document.querySelector('.price.price-secondary').innerText.replace(' Kč', '').replace(' ', '').replace(',', '.');
        if (totalPriceWithoutVat < MIN_PRICE) {
          document.querySelector('.cart-minimum-order').removeAttribute('hidden');
          document.querySelector('.next-step-forward').setAttribute('disabled', '');
        } else {
          document.querySelector('.next-step-forward').removeAttribute('disabled');
          document.querySelector('.cart-minimum-order').setAttribute('hidden', '');
        }
      };

      checkCart();

      document.addEventListener('ShoptetCartUpdated', checkCart);
    }
  }
};

const initFooter = () => {
  const footer = document.querySelector('#footer');

  if (footer) {
    const signature = footer.querySelector('#signature');

    signature.innerHTML = `
      <span>Vytvořilo</span>
      <a href="https://liffstudio.com/" target="_blank" class="liffstudio">
        Liff Studio
      </a>
      <span>
        na platformě
      </span>
      <a href="https://www.shoptet.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" title="Shoptet" class="title" target="_blank">Shoptet</a>
    `;
  }
};


// Init app
window.addEventListener('DOMContentLoaded', () => {
  // initPreheader();
  retinaImages()
  replaceFakeCategoryLinks();
  initHomepageCarousel();
  initHomepageProducts();
  initHomepageBlog();
  initTopNavigationBar();
  initProductDetail();
  initPageDetail();
  initEmptyCart();
  initFAQBlog();
  initFooter();
  initB2B();
});
